export default __webpack_public_path__ + "static/Fascia-1-e7be313e49006afa29a6857ca5adef4d.jpg";